import { render, staticRenderFns } from "./Login-Component.vue?vue&type=template&id=65ff6584&scoped=true&"
import script from "./Login-Component.vue?vue&type=script&lang=js&"
export * from "./Login-Component.vue?vue&type=script&lang=js&"
import style0 from "./Login-Component.vue?vue&type=style&index=0&id=65ff6584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff6584",
  null
  
)

export default component.exports